import type { ProductType } from "@component/assets/AbstractLeadForm/types";

export const getProductTypeByTag = (tag: string): ProductType => {
	switch (tag) {
		case "bankszamla":
			return "RETAIL_ACCOUNT";
		case "szemelyi-kolcson":
			return "PERSONAL_LOAN";
		case "vallalati-hitel":
			return "SME_LOAN";
		case "lakashitel":
			return "MORTGAGE";
		case "lakastakarek":
			return "BUILDING_SOCIETY";
		default:
			return undefined;
	}
};
